import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import Group from 'components/utils/Group'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import Heading from 'LuxKit/Typography/Heading'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
interface MappedProps {
  canViewLuxPlusBenefits: boolean
}
interface Props extends MappedProps {
  bookByDate: string
  travelByDate: string
}

function BnblPackageDatesGift(props: Props) {
  const intl = useIntl()
  const { bookByDate, travelByDate, canViewLuxPlusBenefits } = props

  return (
    <Group direction="vertical" gap={8} tabletGap={16}>
      <BodyText variant="medium">{intl.formatMessage({
        id: 'bxLEUjqXA_mZPIxRSzSM',
        defaultMessage: 'Buying this as a gift locks in today’s price for your recipient. They can choose travel dates later.',
        description: 'Introductory text explaining BNBL gift purchase and date flexibility',
      })}
      </BodyText>

      <Group direction="vertical" gap={0}>
        <Heading variant="heading5" style={{ marginBottom: 8 }}>{intl.formatMessage({
          id: 'kQykh3lu1UqvsS7oHojM',
          defaultMessage: 'How it works',
          description: 'Heading for the how-it-works steps in BNBL gift package dates',
        })}
        </Heading>
        <BodyText variant="medium">
          <FormattedMessage
            id="cI97v3X9dxOWJREXbs8j"
            defaultMessage="<bold>1. Secure your escape today</bold> to lock in the price."
            description="Step 1 of BNBL gift how-it-works: secure the escape"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </BodyText>
        <BodyText variant="medium">
          <FormattedMessage
            id="6csvbL7BrCE8zCTV_Po0"
            defaultMessage="<bold>2. The recipient can choose dates</bold> anytime before <bold>{bookByDate}</bold> in recipient’s account."
            description="Step 2 of BNBL gift how-it-works: recipient chooses dates before deadline"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
              bookByDate: moment(bookByDate).format(DMY_CASUAL_FORMAT),
            }}
          />
        </BodyText>
        <BodyText variant="medium">
          <FormattedMessage
            id="sMZUTu6WIbCVotTDFKP0"
            defaultMessage="<bold>3. Manage their booking online</bold> and travel by <bold>{travelByDate}</bold>."
            description="Step 3 of BNBL gift how-it-works: manage booking and travel by deadline"
            values={{
              bold: (chunks) => <strong>{chunks}</strong>,
              travelByDate: moment(travelByDate).format(DMY_CASUAL_FORMAT),
            }}
          />
        </BodyText>
      </Group>

      <Group direction="vertical">
        <MessageBanner kind="informational-primary" density="compact">
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <LineInfoCircleIcon />
            <BodyText variant="medium">
              {intl.formatMessage({
                id: '3-ai6-3LdzMn0PxVnjNU',
                defaultMessage: 'Subject to availability and surcharges (peak period or property-specific). Any surcharges will be shown before confirming your dates.',
                description: 'Disclaimer about availability and surcharges for BNBL gift package dates',
              })}
            </BodyText>
          </Group>
        </MessageBanner>
        {canViewLuxPlusBenefits && <Caption colour="neutral-three" variant="medium">{intl.formatMessage({
          id: 'STn4Ttqimm9_swl9A9H8',
          defaultMessage: '*Member pricing does not apply when giving a package as a gift.',
          description: 'Caption noting LuxPlus member pricing exclusion for gift packages',
        })}
        </Caption>}
      </Group>
    </Group>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
  }
}

export default connect(mapStateToProps)(BnblPackageDatesGift)
